import { render, staticRenderFns } from "./donutSectionRight.vue?vue&type=template&id=56f9e356&"
import script from "./donutSectionRight.vue?vue&type=script&lang=js&"
export * from "./donutSectionRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports